import { createTheme, Grid, MenuItem, Paper, Select, styled, Box, Typography, FormControl, InputLabel, Skeleton } from "@mui/material";
import { FroalaRichText } from "components/util/FroalaRichtext"
import { RecommendDropdown, Category, Key, SectionNames, ComplianceDropdown } from "constant";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { fetchTabPageData, TabPage } from "redux/slices/tabPagesOptionsSlice";
import "../../../App.css";
import { updateComplianceData } from "redux/slices/updateDataSlice";
import { getComplianceData } from "redux/slices/complianceDataSlice";

const FormStyle = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(4),
    textAlign: "left",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    border: "1px solid #e0e0e0",
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    '& .MuiInputLabel-root': {
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(1),
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
        },
    },
}));

interface Compliance {
    complianceType?: string
    complianceTypeComment?: string
}

const Compliance = (props: any) => {

    const dispatch = useAppDispatch();

    const sectionOptions = useAppSelector((state) =>
        state.dropdownAllOptions.tabData?.find(
            (tab) => tab.tabPageName === SectionNames.COMPLIANCE
        )
    ) as any;

    const updatedComplianceData: any = useAppSelector((state) =>
        state.updateData?.complianceData
    )

    const assetPlanId = useAppSelector(
        (state) => state.getAssetPlanId.assetPlanId
    );
    const complianceData = useAppSelector((state) => state.complianceData)

    useEffect(() => {
        if (!sectionOptions)
            dispatch(fetchTabPageData(SectionNames.COMPLIANCE));
    }, [dispatch, SectionNames.COMPLIANCE]);

    useEffect(() => {
        if (assetPlanId) {
            const payload = {
                assetPlanId: assetPlanId
            }
            dispatch(getComplianceData(payload))
        }
    }, [assetPlanId])

    useEffect(() => {
        if (complianceData?.data) {
            dispatch(updateComplianceData(complianceData?.data))
        }
    }, [complianceData?.data])



    const complianceStatusOptions = useMemo(() => {
        if (!sectionOptions?.data?.options) return [];

        const options = sectionOptions.data.options.find(
            opt => opt.key === "Compliance"
        )?.options || [];

        return [...options].sort((a, b) => a.order - b.order);
    }, [sectionOptions]);

    const handleStatusChange = (value: string) => {
        dispatch(updateComplianceData({
            ...updatedComplianceData,
            complianceType: value
        }
        ))

    }

    const handleTypeCommentsChange = (value: string) => {
        dispatch(updateComplianceData({
            ...updatedComplianceData,
            complianceTypeComment: value
        }
        ))
    }

    return (
        <Box sx={{ p: 2 }}>
            <div className="tab-heading text-center">
                <h3 className="heading">Compliance</h3>
            </div>

            <Grid container justifyContent="center">

                <Grid item xs={12} md={8} lg={6}>
                    {complianceData.loading ? (
                        <Skeleton
                            variant="rounded"
                            width="100%"
                            height={280}
                            animation="wave"
                        />
                    ) : (
                        <FormStyle elevation={0}>
                            <StyledFormControl fullWidth>
                                <div style={{ marginTop: "15px" }}></div>
                                <Select
                                    labelId="compliance-status-label"
                                    value={updatedComplianceData?.complianceType || ""}
                                    onChange={(e) => { handleStatusChange(e.target.value) }}
                                    disabled={props.mode === "view"}
                                >
                                    {complianceStatusOptions.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.text}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </StyledFormControl>

                            <div style={{ marginTop: "74px" }}></div>

                            <FroalaRichText
                                model={updatedComplianceData?.complianceTypeComment || ""}
                                handlesModelChange={handleTypeCommentsChange}
                            />

                        </FormStyle>
                            )}
                    </Grid>
            
            </Grid>
        </Box>
    )
}
export default Compliance;